import { Model } from '@vuex-orm/core'
import Channel from 'src/api/channels.js'

export class CalendarEvent extends Model {
  static entity = 'events'

  static fields () {
    return {
      id: this.attr(null),
      name: this.string(''),
      is_all_day: this.boolean(false),
      begins_at: this.attr(null),
      ends_at: this.attr(null),
      location: this.attr(null),
      category: this.attr(null),
      can: this.attr({}),
      participants: this.attr(null),
      participants_visible: this.attr(null),
      participants_status: this.attr(null),
      participants_status_visible: this.attr(null),
      is_notifiable: this.attr(true),
      description: this.attr(null),
      description_rendered: this.attr(null),
      files: this.attr(null),
      channels: this.attr([]),
      users: this.attr([]),
      user: this.attr(null)
    }
  }

  static async $create (event) {
    const { data } = await Channel.postCreateCalendarEvent(event)
    await this.store().commit('calendar/SET_REFETCH_CALENDAR_VIEW', true)
    return data
  }

  static async $update (event) {
    const { data } = await Channel.putUpdateCalendarSingleEvent(event.id, event)
    await this.store().commit('calendar/SET_REFETCH_CALENDAR_VIEW', true)
    return data
  }

  static async $delete (eventId, payload) {
    const { data } = await Channel.deleteChannelCalendarEvent(eventId, payload)
    await this.store().commit('calendar/SET_REFETCH_CALENDAR_VIEW', true)
    return data
  }

  static async getCalendarEventById (eventId) {
    return Channel.getCalendarSingleEvent(eventId)
  }
}

export default CalendarEvent
